import cls from './shop-card.module.scss'

type ShopCardProps = {
	metro: string
	address: string
	postamat: boolean
	storagePeriod: string
	workShedule: string
	partner: string
	deliveryDate?: string
	deliveryPrice?: string
	phoneNumber?: string
	description?: string
	onSelect?: () => void
}

export const ShopCard = (props: ShopCardProps) => {
	const {
		metro,
		address,
		postamat,
		partner,
		storagePeriod,
		workShedule,
		phoneNumber,
		deliveryDate,
		deliveryPrice,
		description,
		onSelect
	} = props
	const showDeliveryBlock = deliveryDate || deliveryPrice

	return (
		<div className={cls.root}>
			<p className={cls.name}>
				{postamat ? 'Постама' : 'Пункт выдачи '}
				{partner}
			</p>
			<div className={cls.inner}>
				{showDeliveryBlock && (
					<div className={cls.deliveryBlockInfo}>
						{deliveryDate && <p>Дата доставки: {deliveryDate}</p>}
						{deliveryPrice && <p>Стоимость доставки: {deliveryPrice}</p>}
					</div>
				)}
				<div className={cls.addressInfo}>
					<p>м. {metro}</p>
					<p>{address}</p>
				</div>
				<p>Срок хранения - {storagePeriod}</p>
				<p className={cls.workShedule}>{workShedule}</p>
				{onSelect && (
					<button className={cls.moreButton} onClick={onSelect}>
						Подробнее
					</button>
				)}
				{phoneNumber && <p>{phoneNumber}</p>}
				{description && <p className={cls.description}>{description}</p>}
			</div>
		</div>
	)
}
